import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { DisplayMode } from 'cbc-shared-lib';
import { Sgke131aResponseBasicInfo, Sgke131aResponseKouzaDepositreportMeisai } from 'sg-api';

@Component({
  selector: 'app-sgke130d-kouza-depositreport-meisai',
  templateUrl: './sgke130d-kouza-depositreport-meisai.component.html',
  styleUrl: './sgke130d-kouza-depositreport-meisai.component.scss'
})
export class Sgke130dKouzaDepositreportMeisaiComponent implements OnInit, OnDestroy {
  /** モード区分 */
  @Input() mode: string;
  /** 基本情報 */
  @Input() basicInfo: Sgke131aResponseBasicInfo;
  /** 口座入金報告明細 */
  @Input() kouzaDepositreportMeisai: Sgke131aResponseKouzaDepositreportMeisai;

  /** 登録ボタン押下Emitter */
  @Output() onClickAmountRegistEmitter = new EventEmitter();
  /** 編集ボタン押下Emitter */
  @Output() onClickAmountEditEmitter = new EventEmitter();

  /** モード区分_承認 */
  public MODE_APPROVE = DisplayMode.approve;

  /** 入金突合ステータス_未報告 */
  public RECONCILIATION_STATUSCODE_UNREPORTED = "0";
  /** 入金突合ステータス_報告済 */
  public RECONCILIATION_STATUSCODE_REPORTED = "1";
  /** 入金突合ステータス_承認済 */
  public RECONCILIATION_STATUSCODE_APPROVED = "2";

  /** データソース */
  dataSource: MatTableDataSource<Sgke131aResponseKouzaDepositreportMeisai>;

  /** テーブル表示カラム */
  displayedColumnsCol: string[] = [
    'kouzaRcvmnyFclt',
    'kouzaRcvmnyDate',
    'kouzaRcvmnyAmt',
  ];

  /**
   * 初期処理
   * 
   * @memberof Sgke130dKouzaDepositreportMeisaiComponent
   */
  ngOnInit(): void {
    // Table表示データ作成
    if (this.kouzaDepositreportMeisai.rcvmnyNotificationreportMno != null) {
      this.dataSource = new MatTableDataSource<Sgke131aResponseKouzaDepositreportMeisai>([this.kouzaDepositreportMeisai]);
    }
  }

  /**
   * コンポーネントが破棄される際に呼び出されるライフサイクルフック
   * リソースの解放や購読の解除
   * 
   * @memberof Sgke130dKouzaDepositreportMeisaiComponent
   */
  ngOnDestroy(): void {
  }

  /**
   * 登録ボタン押下を親コンポーネントへ通知する処理
   *
   * @memberof Sgke130dKouzaDepositreportMeisaiComponent
   */
  onClickRegist(): void {
    this.onClickAmountRegistEmitter.emit();
  }

  /**
   * 訂正ボタン押下を親コンポーネントへ通知する処理
   *
   * @memberof Sgke130dKouzaDepositreportMeisaiComponent
   */
  onClickEdit(): void {
    this.onClickAmountEditEmitter.emit();
  }

  /**
   * 登録ボタン活性非活性判定
   *
   * @returns {boolean} true:非活性、false:活性
   * @memberof Sgke130dKouzaDepositreportMeisaiComponent
   */
  isResistButtonDisabled(): boolean {
    if (this.mode == this.MODE_APPROVE) {
      // 承認画面の場合、非活性
      return true;
    }

    if (this.kouzaDepositreportMeisai.rcvmnyNotificationreportMno != null) {
      // 口座入金報告明細が存在する場合、非活性
      return true;
    }

    if (this.basicInfo.reconciliationStatuscode == this.RECONCILIATION_STATUSCODE_APPROVED ) {
      // 入金突合ステータスが承認済み場合、非活性
      return true;
    }

    return false;
  }

  /**
   * 訂正ボタン活性非活性判定
   *
   * @returns {boolean} true:非活性、false:活性
   * @memberof Sgke130dKouzaDepositreportMeisaiComponent
   */
  isEditButtonDisabled(): boolean {
    if (this.mode == this.MODE_APPROVE) {
      // 承認画面の場合、非活性
      return true;
    }

    if (this.kouzaDepositreportMeisai.rcvmnyNotificationreportMno == null) {
      // 口座入金報告明細が存在しない場合、非活性
      return true;
    }

    if (this.basicInfo.reconciliationStatuscode == this.RECONCILIATION_STATUSCODE_APPROVED ) {
      // 入金突合ステータスが承認済み場合、非活性
      return true;
    }

    return false;
  }

}
